/**
 * Navigation Items Configuration
 *
 * Centralized navigation structure for the sidebar.
 */

import React from 'react';
import { Folder, Dashboard, Settings, Assessment, CheckCircle } from '@mui/icons-material';

export interface NavigationItem {
  label: string;
  path: string;
  icon: React.ReactElement;
  children?: NavigationItem[];
}

export const navigationItems: NavigationItem[] = [
  {
    label: 'Projects',
    path: '/projects',
    icon: React.createElement(Folder),
  },
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: React.createElement(Dashboard),
  },
  {
    label: 'Reports',
    path: '/reports',
    icon: React.createElement(Assessment),
    children: [
      {
        label: 'Compliance',
        path: '/reports/compliance',
        icon: React.createElement(CheckCircle),
      },
    ],
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: React.createElement(Settings),
  },
];
